const BaseService = require('@/services/BaseService')
const namespace = 'departments'

export default {
    find(id, options, cb) {
        BaseService.get(namespace + '/' + id, options, cb)
    },

    findAll(options, cb) {
        BaseService.get(namespace, options, cb)
    }
}
